module.exports = __webpack_public_path__ + "img/logo-ciphra-login.4fea11a9.svg";